module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_recruitment_text-d14149ed3b6192552c3312445d8bbc88.svg";